<template>
  <div class="linehaul-road-edit-page">
    <div class="row">
      <div class="col12">
        <!-- ***********************  GENERAL INFO   *********************************** -->
        <div class="spl-h3 spl-h3--first">
          General Info
        </div>
        <div class="row">
          <div class="col3">
            <form-label>Date Of Order</form-label>
            <form-datepicker
              v-model="date"
              @input="handleDateInput($event, '', 'date')" />
          </div>
          <div class="col3">
            <form-label>Linehaul Road</form-label>
            <linehaulroad-select
              v-model="defaultFilter.Linehaul_Drive_ID"
              :options="linehaulRoadOptions"
              data-cy="edit-linehaul-road-linehaulroad"
              track-by="value"
              label="label"
              placeholder="Linehaul Road" />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col12">
        <!-- *********************** MAIN NUMBERS   *********************************** -->
        <div class="spl-h3">
          Main Numbers
        </div>
        <div class="row">
          <div class="col3">
            <form-label>No. of Customers</form-label>
            <form-input v-model="defaultFilter.Linehaul_Drive_Detail_Customers" data-cy="edit-linehaul-road-postal-code-from" />
          </div>
          <div class="col3">
            <form-label>No. of Parcels</form-label>
            <form-input v-model="defaultFilter.Linehaul_Drive_Detail_Parcels" data-cy="edit-linehaul-road-postal-code-from" />
          </div>
          <div class="col3">
            <form-label>Weight</form-label>
            <form-input v-model="defaultFilter.Linehaul_Drive_Detail_Weight" data-cy="edit-linehaul-road-postal-code-from" />
          </div>
        </div>
      </div>
    </div>

    <div class="row spl-h3--last">
      <div class="col12">
        <!-- *********************** OPTIONAL NUMBERS   *********************************** -->
        <div class="spl-h3">
          Optional Numbers
        </div>
        <div class="row">
          <div class="col3">
            <form-label>Load Meters</form-label>
            <form-input v-model="defaultFilter.Linehaul_Drive_Detail_Load_Meters" data-cy="edit-linehaul-road-postal-code-to" />
          </div>
          <div class="col3">
            <form-label>T1</form-label>
            <form-input v-model="defaultFilter.Linehaul_Drive_Detail_T1" data-cy="edit-linehaul-road-city" />
          </div>
          <div class="col3">
            <form-label>Number of Stops</form-label>
            <form-input v-model="defaultFilter.Linehaul_Drive_Detail_Stops" data-cy="edit-linehaul-road-city" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Helpers from '@/helpers.vue'
import constants from '@/constants'
import { set, cloneDeep } from 'lodash'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { LinehaulRoad } from '@/webApi/DataModels'
import moment from 'moment'

export default {
  mixins: [Helpers],
  data () {
    return {
      date: moment().toISOString(true),
      defaultFilter: {
        Linehaul_Drive_ID: {},
        Date_Of_Order: moment().toISOString(true),
        Linehaul_Drive_Detail_Customers: '',
        Linehaul_Drive_Detail_Parcels: '',
        Linehaul_Drive_Detail_Weight: '',
        Linehaul_Drive_Detail_Load_Meters: '',
        Linehaul_Drive_Detail_T1: '',
        Linehaul_Drive_Detail_Stops: ''
      },
      constants,
      selectedLinehaulRoad: {}
    }
  },
  created () {
    if (this.currentEditLinehaulRoad.Date_Of_Order) {
      this.date = this.formatDate(this.currentEditLinehaulRoad.Date_Of_Order, false, 'YYYY-MM-DD')
    }
  },
  computed: {
    ...mapGetters('linehaulRoad', ['linehaulRoadOptions']),
    ...mapState('linehaulRoad', ['currentEditLinehaulRoad'])
  },
  watch: {
    selectedLinehaulRoad: function () {
      if (this.selectedLinehaulRoad !== -1) {
        this.defaultFilter.Linehaul_Drive_ID = this.selectedLinehaulRoad
        this.setCurrentEditLinehaulRoad(set(cloneDeep(this.currentEditLinehaulRoad), 'Linehaul_Road_Filter', this.defaultFilter))
        this.date = this.formatDate(this.defaultFilter.Linehaul_Drive_Detail_Date, false, 'YYYY-MM-DD')
      }
    },
    defaultFilter: {
      handler: function () {
        // update the linehaul road filter everytime the parcel filter changes
        this.setCurrentEditLinehaulRoad(set(cloneDeep(this.currentEditLinehaulRoad), 'Linehaul_Road_Filter', this.defaultFilter))
      },
      deep: true
    }
  },
  mounted () {
    this.defaultFilter = cloneDeep(this.currentEditLinehaulRoad)
    if (this.defaultFilter.Linehaul_Drive_ID < 0) {
      this.defaultFilter.Linehaul_Drive_ID = {}
    }
    if (this.currentEditLinehaulRoad.Linehaul_Drive_ID !== -1) {
      this.set_LinehaulRoad_Dropdown_By_ID(this.currentEditLinehaulRoad.Linehaul_Drive_ID)
    }
  },
  methods: {
    ...mapMutations('linehaulRoad', ['setCurrentEditLinehaulRoad']),
    onCountriesSelected (linehaulroads) {
      this.Linehaul_Drive_ID = linehaulroads
    },
    set_LinehaulRoad_Dropdown_By_ID (linehaulRoadID) {
      for (var i in this.linehaulRoadOptions) {
        if (this.linehaulRoadOptions[i].value === linehaulRoadID) {
          this.selectedLinehaulRoad = this.linehaulRoadOptions[i]
          return
        }
      }
    },
    // Handles input changes in the date fiels,
    // only one selection is possible so it
    // resets the selected date object if another
    // type is selected
    handleDateInput (value, type, specifier) {
      if (specifier === 'date') {
        this.defaultFilter.Linehaul_Drive_Detail_Date = this.formatDate(value, false, 'YYYY-MM-DD')
      }
      this.writeDateFilter()
      this.$forceUpdate()
    },
    writeDateFilter () {
      // Everytime the date page is changed write it into a usable format for storing
      var linehaulRoad:LinehaulRoad = cloneDeep(this.currentEditLinehaulRoad) as LinehaulRoad
      this.setCurrentEditLinehaulRoad(linehaulRoad)
    }
  }
}
</script>

<style lang="scss">
  @import '../../../variables.scss';

  .linehaul-road-edit-page {
    margin-bottom: 100px;
    background-color: #fff7e7;
    & .spl-h3 {
      margin-top: 30px;
      margin-bottom: 40px;
      position: relative;

      &::before {
        content: "";
        border-bottom: 3px solid black;
        opacity: 0.3;
        width: 30px;
        position: absolute;
        bottom: -13px;
      }
    }
    & .spl-h3--first {
      padding-top: 30px;
      margin-top: 0px !important;
    }
    & .spl-h3--last {
      padding-bottom: 100px;
    }
    &__date {
      display: grid;
      grid-template-columns: 24% 24% 24% 24%;
      grid-gap: 7px;
      width: 100%;
      padding-top: 1%;
      position: relative;

      &--active {
        background-color: $grey_80 !important;
      }

      &--close-linehaul-road, &--open-linehaul-road {
        position: relative;
      }

      div {
        background-color: $grey_95;
        border-radius: 5px;
        padding: 3px;
      }

      .spl-checkbox-group__item__label {
        margin-bottom: 10px;
      }
    }

    &__linehaul-road {
      float: left;
      display: flex;
    }

    &__fields, &__postal, &__references, &__weekend-delivery {
      display: grid;
      grid-template-columns: 24% 24% 24% 24%;
      grid-gap: 7px;
      width: 100%;
      padding-top: 1%;
      div {
        margin-bottom: 10px;
      }
    }
    &__fields:last-child, &__postal:last-child, &__references:last-child, &__weekend-delivery:last-child {
      padding-bottom: 100px;
    }
  }
</style>
